import { render } from "./FlightSearch.vue?vue&type=template&id=1b6d4bd2"
import script from "./FlightSearch.vue?vue&type=script&lang=js"
export * from "./FlightSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__